import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Separator } from "../ui/separator";

const ViewChallengeBlock = (props) => {
  const { item, index } = props;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Challenge {index + 1}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <h3 className="font-semibold mb-2">{item.challenge_name}</h3>
          <div className="space-y-1 text-sm text-gray-600">
            {item?.event.filter(notingroup).map((eventitem) => (
              <div key={`event_${eventitem.event_id}`}>
                • {eventitem.event_name}
              </div>
            ))}
            {item?.task.filter(notingroup).map((taskitem) => (
              <div key={`task_${taskitem.task_id}`}>• {taskitem.task_name}</div>
            ))}
            {item?.group.map((taskitem) => (
              <div key={`group_${taskitem.task_id}`}>• {taskitem.group_name}</div>
            ))}
          </div>
        </div>
        <Separator />
        <div className="text-sm text-gray-500">
          {new Date(item.start_date).getDate()}{" "}
          {new Date(item.start_date).toLocaleString("en-US", {
            month: "short",
          })}{" "}
          To {new Date(item.end_date).getDate()}{" "}
          {new Date(item.end_date).toLocaleString("en-US", { month: "short" })}
        </div>
      </CardContent>
    </Card>
  );
};

function notingroup(i) {
  return i.group_id === "" || i.group_id === undefined || i.group_id === null;
}

export default ViewChallengeBlock;
